import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { RootState } from "store/rootReducer";
import { API_URL } from "config";
import userStorage from "store/UserStorage";
import { batch } from "react-redux";
import { setResponseMessage } from "../adminSlice";
import { FilterAdminState } from "./types";

const initialState: FilterAdminState = {
  filters: [],
  filter: undefined,
  loading: false,
};

const filterAdmin = createSlice({
  name: "filterAdminSlice",
  initialState,
  reducers: {
    setFilters(state, action) {
      state.filters = action.payload;
    },

    setFilter(state, action) {
      state.filter = action.payload;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
  },
});
export const { setLoading, setFilters, setFilter } = filterAdmin.actions;
export const selectLoading = (state: RootState) => state.filterAdmin.loading;
export const selectFilter = (state: RootState) => state.filterAdmin.filter;

export const selectAllFilters = (state: RootState) => state.filterAdmin.filters;

export const fetchAllFilters = (objectType: string) => async (
  dispatch: any
) => {
  try {
    dispatch(setLoading(true));
    const result = await axios.get(
      `${API_URL}/admin/filters?objectType=${objectType}`
    );
    batch(() => {
      console.log(result.data.data);
      dispatch(setFilters(result.data.data));
      dispatch(setResponseMessage({ message: "", hasError: false }));
      dispatch(setLoading(false));
    });
  } catch (error: any) {
    batch(() => {
      dispatch(setResponseMessage({ message: error.message, hasError: true }));
      dispatch(setLoading(false));
    });

    console.log(`Error in fetchAllTags: ${error.message}`);
  }
};

export const fetchFilter = (id: string) => async (dispatch: any) => {
  try {
    dispatch(setLoading(true));
    const result = await axios.get(`${API_URL}/admin/filter-values/${id}`);
    batch(() => {
      dispatch(setFilter(result.data.data));
      dispatch(setResponseMessage({ message: "", hasError: false }));
      dispatch(setLoading(false));
    });
  } catch (error: any) {
    batch(() => {
      dispatch(setResponseMessage({ message: error.message, hasError: true }));
      dispatch(setLoading(false));
    });

    console.log(`Error in fetchAllTags: ${error.message}`);
  }
};

export const addFilter = (
  data: any,
  onUploadProgress: (e: ProgressEvent<EventTarget>) => void
) => async (dispatch: any) => {
  try {
    dispatch(setLoading(true));
    const json = JSON.stringify({ availableFilters: data.values });

    let token = userStorage.getUser();
    const response = await axios.put(
      `${API_URL}/admin/filters/${data.id}`,
      { data: json },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        onUploadProgress,
      }
    );
    dispatch(
      setResponseMessage({
        message: "Успешно добавихте филтъра.",
        hasError: false,
      })
    );
  } catch (error: any) {
    batch(() => {
      dispatch(setResponseMessage({ message: error.message, hasError: true }));
      dispatch(setLoading(false));
    });
  }
};

export default filterAdmin.reducer;
